import axios, { AxiosResponse } from "axios";
import { getAuth } from "src/modules/Auth/Core";
import { axiosInstance } from "src/services/axiosSetup";
import * as API from "src/services/consts/Products";


export function fetchAllProductsApiRequest(query: string): Promise<AxiosResponse> {
    query = query ? "?" + query.replace("page=1&items_per_page=30","") : ""
    return axiosInstance.get(`${API.URL_FETCH_ALL_PRODUCTS}${query}`).then((d: AxiosResponse) => d.data);
}

export async function getProductDetailByIDApiRequest(id: any): Promise<AxiosResponse> {
    return axiosInstance.get(`${API.GET_DETAILS_PRODUCTS_BY_ID}/${id}`).then((d: AxiosResponse) => d.data);
}

